import { render, staticRenderFns } from "./Spreadsheet.vue?vue&type=template&id=08139980"
import script from "./Spreadsheet.vue?vue&type=script&lang=js"
export * from "./Spreadsheet.vue?vue&type=script&lang=js"
import style0 from "./Spreadsheet.vue?vue&type=style&index=0&id=08139980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports